import { PaymentPopup } from "../domain/Installation";

export class VuePaymentPopup implements PaymentPopup {
    showed: boolean;
    show_file_field: boolean;
    resolve_prom

    constructor() {
        this.showed = false;
        this.show_file_field = true
    }

    show() {
        this.showed = true;
        return new Promise((resolve) => {
            this.resolve_prom = resolve
        });
    }

    close(file) {
        this.showed = false;
        this.resolve_prom(file);
    }
}
